var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"selection-box"},[_c('b-form-checkbox-group',{class:{'readonly': _vm.readonly},attrs:{"checked":_vm.selected,"autofocus":_vm.autofocus,"disabled":_vm.disabledData || _vm.readonly,"options":_vm.buttonOptions,"required":_vm.required,"buttons":""},on:{"change":_vm.selection}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }